export const FIRST_ORDER_NUDGE_MESSAGE_INDEX = 900001
export const DEFAULT_FIRST_ORDER_NUDGE_DELAY_DAYS = 2
export const DEFAULT_FIRST_ORDER_NUDGE_MESSAGE =
  'Hi {{customerName}}, just checking in - were you happy with your first {{businessName}} order? Reply YES or NO.'

export function getFirstOrderNudgeConfig(automation) {
  const rawRule = automation?.rule
  let rule = rawRule || {}
  if (typeof rawRule === 'string') {
    try { rule = JSON.parse(rawRule) } catch { rule = {} }
  }

  const params = rule?.params || {}
  const parsedDelay = Number(params.noResponseNudgeDelayDays)
  return {
    enabled: params.noResponseNudgeEnabled === true,
    delayDays: Number.isFinite(parsedDelay) && parsedDelay > 0
      ? parsedDelay
      : DEFAULT_FIRST_ORDER_NUDGE_DELAY_DAYS,
    message: String(params.noResponseNudgeMessage || DEFAULT_FIRST_ORDER_NUDGE_MESSAGE).trim(),
  }
}

export function getFirstOrderNudgeSendAfter(sentAt, delayDays) {
  const base = sentAt instanceof Date ? sentAt.getTime() : Date.parse(sentAt)
  const safeBase = Number.isFinite(base) ? base : Date.now()
  const parsedDelay = Number(delayDays)
  const safeDelay = Number.isFinite(parsedDelay) && parsedDelay > 0
    ? parsedDelay
    : DEFAULT_FIRST_ORDER_NUDGE_DELAY_DAYS
  return new Date(safeBase + safeDelay * 24 * 60 * 60 * 1000).toISOString()
}

export function isFailedFirstOrderInitialMessage(outbox, mappedStatus) {
  return mappedStatus === 'failed'
    && outbox?.automation_key === 'first_order'
    && Number(outbox?.message_index) === 0
}
